export default __webpack_public_path__ + "static/underline-before-c323d19a91a247d1e7053c56ccd3fe88.png";